import React from "react";
import PropTypes from "prop-types";
// @mui
import MuiSwitch from "@mui/material/Switch";
// Limitless imports
import Typography from "../../data-display/typography/Typography";
import Grid from "../../layout/Grid";
import { useTranslation } from "@limitless/common/hooks";
import Divider from "../../data-display/divider/Divider";
import AnimationWrapper from "../../components/animation-wrapper/AnimationWrapper";
const SettingSwitch = ({
  items,
  children,
  showAnimation = false
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(AnimationWrapper, {
    showAnimation: showAnimation
  }, items.map((item, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 10,
    sm: 11
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    sx: {
      color: theme => theme.palette.grey[4],
      paddingBottom: theme => theme.spacing(1.5)
    }
  }, t(item.titleText)), /*#__PURE__*/React.createElement(Grid, {
    sx: {
      maxWidth: 450
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: {
      color: theme => theme.palette.grey[2]
    }
  }, t(item.subTitleText)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2,
    sm: 1,
    container: true,
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(MuiSwitch, {
    checked: item === null || item === void 0 ? void 0 : item.checked,
    onChange: item === null || item === void 0 ? void 0 : item.handleSwitchChange,
    disabled: item === null || item === void 0 ? void 0 : item.disabled,
    sx: {
      marginRight: theme => theme.spacing(0)
    }
  }))), item.children && /*#__PURE__*/React.createElement(Grid, {
    pt: 3
  }, item.children), (items.length > 1 && items.length !== index + 1 || children) && /*#__PURE__*/React.createElement(Grid, {
    pt: 3,
    pb: 3
  }, /*#__PURE__*/React.createElement(Divider, null)))), children && /*#__PURE__*/React.createElement(Grid, null, children));
};
SettingSwitch.propTypes = {
  children: PropTypes.node,
  items: PropTypes.array.isRequired,
  showAnimation: PropTypes.bool
};
export default SettingSwitch;